import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconAccessible = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconAccessible",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M400-80q-83 0-141-58t-59-142q0-51 23-94t61-70q14-10 30-7t26 17 8 30-17 26q-23 17-37 43t-14 55q0 50 35 85t85 35q30 0 56-14t42-37q10-14 26-16t30 7 17 26-7 30q-27 38-70 61t-94 23m320 0q-17 0-28-11t-12-29v-160H480q-33 0-56-23t-24-57v-240q0-33 24-56t56-24q24 0 42 11t37 33q45 54 82 79t78 33q17 3 29 15t12 29-12 28-29 8q-44-8-85-28t-74-46v138h120q33 0 57 24t23 56v180q0 17-11 29t-29 11M480-720q-33 0-56-23t-24-57 24-56 56-24 57 24 23 56-23 57-57 23"
  })
}));
IconAccessible.displayName = 'IconAccessible';